/* Ladervelger — same conventions as battery-finder.js: hash-mirrored state,
 * lazy live price via /products/{handle}.js (404 hides), no dependencies.
 * Safety rule shared with the PDP attach block: battery chemistry must be in
 * the charger's EXPLICIT support list. Amp band 10-20% of entered Ah
 * (widened to 8-25% when the strict band is empty); no Ah -> no amp filter. */
(function () {
  'use strict';

  var root = document.getElementById('pv-cf');
  if (!root) return;

  var wizard = document.getElementById('pv-cf-wizard');
  var stepVoltage = document.getElementById('pv-cf-step-voltage');
  var stepAh = document.getElementById('pv-cf-step-ah');
  var resultsWrap = document.getElementById('pv-cf-results-wrap');
  var heading = document.getElementById('pv-cf-results-heading');
  var grid = document.getElementById('pv-cf-grid');
  var emptyBox = document.getElementById('pv-cf-empty');
  var resetBtn = document.getElementById('pv-cf-reset');

  var chargers = [];
  var priceCache = {};
  var applyingHash = false;

  fetch(root.dataset.jsonUrl, { cache: 'no-cache' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (data) {
      chargers = data.chargers || [];
      wizard.hidden = false;
      readHash();
      render();
    })
    .catch(function () { /* fallback categories carry the page */ });

  function state() {
    var f = wizard.elements;
    return { chem: f.chem.value || '', voltage: f.voltage.value || '', ah: f.ah.value || '' };
  }

  function writeHash() {
    if (applyingHash) return;
    var s = state();
    var parts = [];
    Object.keys(s).forEach(function (k) { if (s[k]) parts.push(k + '=' + encodeURIComponent(s[k])); });
    var next = parts.length ? '#' + parts.join('&') : '#';
    if (('#' + location.hash.replace(/^#/, '')) !== next) location.hash = next;
  }

  function readHash() {
    var raw = location.hash.replace(/^#/, '');
    var s = {};
    raw.split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i > 0) s[kv.slice(0, i)] = decodeURIComponent(kv.slice(i + 1));
    });
    applyingHash = true;
    setRadio('chem', s.chem || '');
    setRadio('voltage', s.voltage || '');
    wizard.elements.ah.value = /^\d+$/.test(s.ah || '') ? s.ah : '';
    applyingHash = false;
  }

  function setRadio(name, value) {
    wizard.querySelectorAll('input[name="' + name + '"]').forEach(function (r) {
      r.checked = (r.value === value);
    });
  }

  function filtered() {
    var s = state();
    if (!s.chem) return null;
    var v = s.voltage ? parseInt(s.voltage, 10) : null;
    var ah = parseFloat(s.ah) || null;
    var pool = chargers.filter(function (c) {
      if (c.chems.indexOf(s.chem) === -1) return false;
      if (v !== null && c.volts.indexOf(v) === -1) return false;
      if (ah && c.ahMin && ah < c.ahMin) return false;
      if (ah && c.ahMax && ah > c.ahMax) return false;
      return true;
    });
    if (ah) {
      var band = pool.filter(function (c) { return c.amp >= 0.10 * ah && c.amp <= 0.20 * ah; });
      if (!band.length) band = pool.filter(function (c) { return c.amp >= 0.08 * ah && c.amp <= 0.25 * ah; });
      pool = band;
      var ideal = 0.15 * ah;
      pool.sort(function (a, b) {
        if (a.available !== b.available) return a.available ? -1 : 1;
        return Math.abs(a.amp - ideal) - Math.abs(b.amp - ideal);
      });
    }
    return pool;
  }

  function render() {
    var s = state();
    var list = filtered();
    stepVoltage.hidden = !s.chem;
    stepAh.hidden = !s.chem;
    resetBtn.hidden = !s.chem;
    if (!list) { resultsWrap.hidden = true; return; }

    // hide voltage classes with no chargers for the chosen chemistry
    var byVolt = {};
    chargers.forEach(function (c) {
      if (c.chems.indexOf(s.chem) !== -1) {
        c.volts.forEach(function (v) { byVolt[v] = (byVolt[v] || 0) + 1; });
      }
    });
    stepVoltage.querySelectorAll('[data-voltage]').forEach(function (chip) {
      var n = byVolt[parseInt(chip.dataset.voltage, 10)] || 0;
      chip.hidden = n === 0;
      chip.querySelector('span').textContent = chip.dataset.voltage + 'V (' + n + ')';
    });

    resultsWrap.hidden = false;
    emptyBox.hidden = list.length !== 0;
    heading.textContent = list.length ? list.length + ' ladere passer' : '';
    grid.innerHTML = '';
    list.slice(0, 24).forEach(function (c) { grid.appendChild(card(c)); });
    observePrices();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(c) {
    var li = document.createElement('li');
    li.className = 'pv-bf__item card-wrapper';
    li.dataset.handle = c.handle;
    var specs = [c.volts.join('/') + 'V', c.amp + 'A'];
    if (c.channels) specs.push(c.channels + ' kanaler');
    specs.push(c.chems.join('/'));
    li.innerHTML =
      '<div class="card pv-bf__card">' +
        '<a class="pv-bf__cardlink full-unstyled-link" href="/products/' + c.handle + '">' +
          '<div class="pv-bf__media">' +
            (c.img ? '<img src="' + c.img + '" loading="lazy" alt="' + esc(c.title) + '" width="180" height="180">' : '') +
            (!c.available ? '<span class="pv-bf__badge pv-bf__badge--oos">' + (document.documentElement.lang === 'sv' ? 'Slut i lager' : 'Utsolgt') + '</span>' : '') +
            (c.b2b ? '<span class="pv-bf__badge pv-bf__badge--b2b">Kun bedrift</span>' : '') +
          '</div>' +
          '<div class="card__content pv-bf__content">' +
            '<h3 class="card__heading pv-bf__title">' + esc(c.title) + '</h3>' +
            '<div class="tech-badge-container">' +
              specs.map(function (t) { return '<span class="tech-badge-item">' + esc(t) + '</span>'; }).join('') +
            '</div>' +
            '<div class="pv-bf__price" data-price>&nbsp;</div>' +
          '</div>' +
        '</a>' +
      '</div>';
    return li;
  }

  var io = null;
  function observePrices() {
    if (io) io.disconnect();
    var load = function (el) {
      var handle = el.dataset.handle;
      var slot = el.querySelector('[data-price]');
      if (!slot) return;
      if (priceCache[handle]) { slot.innerHTML = priceCache[handle]; return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (r.status === 404) { el.remove(); return null; }
          return r.ok ? r.json() : null;
        })
        .then(function (p) {
          if (!p) return;
          var html = '<strong>' + Math.round(p.price / 100).toLocaleString('nb-NO') +
                     ' kr</strong> <small>inkl. mva</small>';
          priceCache[handle] = html;
          slot.innerHTML = html;
        })
        .catch(function () {});
    };
    if (!('IntersectionObserver' in window)) {
      grid.querySelectorAll('.pv-bf__item').forEach(load);
      return;
    }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); load(e.target); }
      });
    }, { rootMargin: '200px' });
    grid.querySelectorAll('.pv-bf__item').forEach(function (el) { io.observe(el); });
  }

  wizard.addEventListener('change', function () { writeHash(); render(); });
  var t = null;
  wizard.addEventListener('input', function (e) {
    if (e.target.type !== 'number') return;
    clearTimeout(t);
    t = setTimeout(function () { writeHash(); render(); }, 350);
  });
  wizard.addEventListener('submit', function (e) { e.preventDefault(); });
  resetBtn.addEventListener('click', function () {
    wizard.reset();
    setRadio('chem', '');
    writeHash();
    render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.addEventListener('hashchange', function () { readHash(); render(); });
})();
